const keys = {
  portfolioSiteAPI: 'qfYTGYLMKD7FTrzwiFDer2MyBVxR3uFOaJLAK1dj',
}

export default keys
